import { observable } from "mobx";
import { Type } from "class-transformer";
import CustomerRefundCandidatePreviewFeeResponse from "./customerRefundCandidatePreviewFeeResponse";
import CustomerRefundCandidatePreviewRefundPaymentResponse from "./customerRefundCandidatePreviewRefundPaymentResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CustomerPartialRefundCandidatePreviewDetailResponse {
  /**
   * Charge price.
   */
  @observable
  chargePrice!: number;

  /**
   * New charge price.
   */
  @observable
  newChargePrice!: number;

  /**
   * Raw refund amount.
   */
  @observable
  rawRefundAmount!: number;

  /**
   * Refund amount.
   */
  @observable
  refundAmount!: number;

  /**
   * Refund amount is returnable.
   */
  @observable
  isReturnable!: boolean;

  @observable
  @Type(() => CustomerRefundCandidatePreviewRefundPaymentResponse)
  refundPayment!: CustomerRefundCandidatePreviewRefundPaymentResponse;

  /**
   * Refund fees.
   */
  @observable
  @Type(() => CustomerRefundCandidatePreviewFeeResponse)
  fees!: CustomerRefundCandidatePreviewFeeResponse[];
}
